module.exports = __webpack_public_path__ + "static/b9-93980be13e6e5629c0daf3dd30b7bb6f.png";